import { render } from "./FailedMessages.vue?vue&type=template&id=4b94d0bf&scoped=true"
import script from "./FailedMessages.vue?vue&type=script&lang=js"
export * from "./FailedMessages.vue?vue&type=script&lang=js"

import "./FailedMessages.vue?vue&type=style&index=0&id=4b94d0bf&scoped=true&lang=css"

import exportComponent from "/builds/flowberry1/flowberry/user-interface/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b94d0bf"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTd from 'quasar/src/components/table/QTd.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QInput,QIcon,QCard,QCardSection,QTable,QTd});
